module.exports = __webpack_public_path__ + "static/assets/home_pin.png";